import type { IconSvgObject } from './types';

const PlaneIcon: IconSvgObject = [
  ["path", { d: "M10.5 16.25L20.3787 6.37132C20.7765 5.9735 21 5.43393 21 4.87132C21 3.69975 20.0503 2.75 18.8787 2.75C18.3161 2.75 17.7765 2.9735 17.3787 3.37132L7.5 13.25H4L3 14.75L7.5 16.25L9 20.75L10.5 19.75V16.25Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.5 9.75V18.25L16 19.75L13.5 14.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 6.25H5.5L4 7.75L9.5 10.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PlaneIcon;
